import { render, staticRenderFns } from "./creatSection.vue?vue&type=template&id=55494b6b&scoped=true"
import script from "./creatSection.vue?vue&type=script&lang=js"
export * from "./creatSection.vue?vue&type=script&lang=js"
import style0 from "./creatSection.vue?vue&type=style&index=0&id=55494b6b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55494b6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55494b6b')) {
      api.createRecord('55494b6b', component.options)
    } else {
      api.reload('55494b6b', component.options)
    }
    module.hot.accept("./creatSection.vue?vue&type=template&id=55494b6b&scoped=true", function () {
      api.rerender('55494b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/section/creatSection.vue"
export default component.exports